export enum SCREEN_HEIGHT {
  HEADER = 60,
  GMAP = 60,
}
